import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-devicemanger-list',
  templateUrl: './devicemanger-list.component.html',
  styleUrls: ['./devicemanger-list.component.scss']
})
export class DevicemangerListComponent implements OnInit {
  public radioGroupForm: FormGroup;


  constructor(private formBuilder: FormBuilder, private modalService: NgbModal) { }
  closeResult: string;

  displayedColumns: string[] = ['deviceName', 'deviceId', 'deviceType', 'location', 'status', 'actions'];
  dataSource = new MatTableDataSource<deviceManagerData>(ELEMENT_DATA);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;


   
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
  config(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
 

  ngOnInit() {
    this.radioGroupForm = this.formBuilder.group({
      'model': 1
    });
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

};

export interface deviceManagerData {
  status: string;
  deviceName: string;
  deviceId: number;
  deviceType: string;
  location: string;
}


const ELEMENT_DATA: deviceManagerData[] = [
  {status : 'online', deviceName: 'test device', deviceId: 1.0079,deviceType:"type1", location: 'India'},
  {status: 'offline', deviceName: 'sample', deviceId: 4.0026,deviceType:"type2", location: 'Australia'},
  {status: 'online',  deviceName: 'sample1', deviceId: 6.941,deviceType:"type3", location: 'US'},
  {status: 'offline', deviceName: 'test device', deviceId: 9.0122,deviceType:"type4", location: 'UK'},
  {status: 'online',  deviceName: 'sample2', deviceId: 10.811,deviceType:"type5", location: 'Paris'},
  {status: 'offline', deviceName: 'sample3', deviceId: 12.0107,deviceType:"type6", location: 'singapore'},
  {status: 'offline', deviceName: 'test device', deviceId: 14.0067,deviceType:"type7", location: 'N'},
  {status: 'offline', deviceName: 'sample4', deviceId: 15.9994,deviceType:"type8", location: 'O'},
  {status: 'offline', deviceName: 'sample5', deviceId: 18.9984,deviceType:"type9", location: 'F'},
  {status: 'online',  deviceName: 'sample6', deviceId: 20.1797,deviceType:"type10", location: 'Ne'},
  {status: 'offline', deviceName: 'device', deviceId: 22.9897,deviceType:"type11", location: 'Na'},
  {status: 'offline', deviceName: 'test device', deviceId: 24.305,deviceType:"type12", location: 'Mg'}
];

